exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".engine-key-metrics-view[data-v-91216710] .main-stat .value{color:#ea6e00}.engine-key-metrics-view[data-v-91216710] .simple-graph .path{stroke:#ea6e00}", ""]);
